<template>
  <div>
    <!-- BEGIN breadcrumb -->
    <ol class="breadcrumb float-xl-end">
      <li class="breadcrumb-item"><a href="/app/dashboard">Home</a></li>
      <li class="breadcrumb-item">
        <a href="/app/ordem-servico">Ordens de serviços</a>
      </li>
      <li class="breadcrumb-item">Zerar Rastreabilidade</li>
    </ol>
    <!-- END breadcrumb -->
    <!-- BEGIN page-header -->
    <h1 class="page-header">Zerar Rastreabilidade</h1>
    <!-- END page-header -->
    <panel :noButton="true">
      <div
        slot="header"
        class="w-100 d-flex align-items-center justify-content-between"
      >
        <span>Selecione as ordens de serviço para zerar a rastreabilidade </span>
      </div>
      <vue-good-table
        :key="tableKey"
        ref="tabelaRastreabilidade"
        :columns="columns"
        :rows="rows"
        :lineNumbers="false"
        :isLoading="isLoad"
        :styleClass="'vgt-table striped'"
        :search-options="{ enabled: true, placeholder: 'Pesquisar' }"
        :pagination-options="pageOptions"
        :selectOptions="{
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
          selectionText: 'ordem(ns) de serviço selecionada(s)',
          clearSelectionText: 'limpar seleção'
        }"
        @on-selected-rows-change="selectionChanged"
      >
        <div slot="selected-row-actions">
          <button
            v-if="checkFuncionalidade(21) || usuarioLiberado"
            class="btn btn-danger btn-sm"
            @click="zerarRastreabilidade"
          >
            Zerar Rastreabilidade
          </button>
        </div>
        <template #loadingContent>
          <div class="text-center">
            <b-spinner
              class="align-middle"
              style="width: 2rem; height: 2rem"
            ></b-spinner>
            <strong style="margin-left: 0.5rem">Carregando...</strong>
          </div>
        </template>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'id'">
            {{ props.row.id.toString().padStart(6, '0') }}
          </span>
          <span v-if="props.column.field == 'nome_arquivo'">
            {{ props.row.nome_arquivo.toString() }}
          </span>
          <span v-if="props.column.field == 'total_paginas'">
            {{ props.row.total_paginas.toString() }}
          </span>
          <span v-if="props.column.field == 'quantidade_caixas'">
            {{ props.row.quantidade_caixas.toString() }}
          </span>
          <span v-if="props.column.field == 'dt_limite'">
            {{ props.row.dt_limite.toString() }}
          </span>
          <span v-if="props.column.field == 'status'">
            {{ props.row.status.toString() }}
          </span>
          <span v-if="props.column.field == 'cliente'">
            {{ props.row.cliente.nome.toString() }}
          </span>
          <span v-if="props.column.field == 'produto'">
            {{ props.row.produto.nome.toString() }}
          </span>
        </template>
      </vue-good-table>
    </panel>
  </div>
</template>

<script>
import axios from 'axios'
import CheckFunc from '../../../mixins/CheckFunc'
import { getCurrentUser } from '../../../utils'

export default {
  components: {},
  mixins: [CheckFunc],
  data() {
    return {
      isLoad: false,
      selectedRows: [],
      tableKey: 0,
      columns: [
        {
          label: 'OS',
          field: 'id'
        },
        {
          label: 'Arquivo',
          field: 'nome_arquivo'
        },
        {
          label: 'Qtd Páginas',
          field: 'total_paginas'
        },
        {
          label: 'Qtd Caixas',
          field: 'quantidade_caixas'
        },
        {
          label: 'Dt Max Entrega',
          field: 'dt_limite'
        },
        {
          label: 'Status',
          field: 'status'
        },
        {
          label: 'Cliente',
          field: 'cliente'
        },
        {
          label: 'Produto',
          field: 'produto'
        }
      ],
      rows: []
    }
  },
  methods: {
    selectionChanged(params) {
      this.selectedRows = params.selectedRows
    },
    zerarRastreabilidade() {
      if (!this.selectedRows.length) return
      let Swal = this.$swal
      let data = {
        ordens_servicos: this.selectedRows.map(row => row.id)
      }
      let url = 'producao/rastreabilidade/zera-rastreabilidade'
      let method = 'post'
      Swal.fire({
        title: 'Zerar rastreabilidade',
        text:
          `Tem certeza que deseja zerar a rastreabilidade de ${this.selectedRows.length} ` +
          'ordem(ns) de serviço selecionada(s)? Esta ação não poderá ser desfeita.',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Zerar',
        confirmButtonColor: '#dc3545',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return axios({ method, url, data })
            .then(res => {
              return res.data
            })
            .then(res => {
              return res
            })
            .catch(error => {
              Swal.showValidationMessage(
                `Erro: ${error.response.data.mensagem}`
              )
            })
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then(result => {
        if (result.isConfirmed) {
          Swal.fire({
            position: 'top-center',
            icon: 'success',
            title: 'Rastreabilidade zerada com sucesso!',
            showConfirmButton: false,
            timer: 1500
          })
          this.selectedRows = []
          this.tableKey++
          this.loadItens()
        }
      })
    },
    async loadItens() {
      this.isLoad = true
      await axios
        .get(this.apiUrl)
        .then(res => {
          return res.data.dados
        })
        .then(res => {
          this.rows = res.data
          this.isLoad = false
        })
    }
  },
  computed: {
    // Liberado também, direto no código, para o usuário id 28 - ver SidebarMenu.vue.
    usuarioLiberado() {
      const user = getCurrentUser()
      return !!user && parseInt(user.id) === 28
    },
    apiUrl() {
      return 'producao/ordem-servico?per_page=100000000000&concluidos=false'
    },
    pageOptions() {
      return {
        enabled: true,
        mode: 'records',
        perPage: 50,
        position: 'bottom',
        perPageDropdown: [20, 50, 100],
        dropdownAllowAll: false,
        setCurrentPage: 1,
        jumpFirstOrLast: true,
        firstLabel: 'Primeira Página',
        lastLabel: 'Última Página',
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Linhas por página',
        ofLabel: 'de',
        pageLabel: 'página', // for 'pages' mode
        allLabel: 'Todos',
        infoFn: params =>
          `Quantidade de linhas ${
            params.lastRecordOnPage - params.firstRecordOnPage + 1
          } - Página ${params.currentPage} de ${
            params.totalPage
          } - Total Ordens de serviços ${params.totalRecords}`
      }
    }
  },
  mounted() {
    this.loadItens()
  }
}
</script>
